import React from 'react';
import palette from '@solid-ui-theme/palette';

const ArrowIcon = ({ color = palette.gray700, style }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={style}
  >
    <path
      d='M12.5 15L7.5 10L12.5 5'
      stroke={color}
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default ArrowIcon;
